import React, { useState } from 'react';

const METIERS = [
  { id: 'maconnerie', label: 'Maçonnerie' },
  { id: 'plomberie', label: 'Plomberie' },
  { id: 'electricite', label: 'Électricité' },
  { id: 'carrelage', label: 'Carrelage' },
  { id: 'peinture', label: 'Peinture' },
  { id: 'toiture', label: 'Couverture / Toiture' },
  { id: 'menuiserie', label: 'Menuiserie' },
  { id: 'clim', label: 'Climatisation / Chauffage' },
];

const PLATEFORMES = [
  {
    categorie: '⭐ Incontournables',
    items: [
      { nom: 'Travaux.com', desc: 'Leader — 70 000 projets/mois, 25 000 artisans inscrits', url: 'https://www.travaux.com/professionnels', gratuit: true },
      { nom: 'Habitatpresto Pro', desc: 'Leads qualifiés vérifiés par des conseillers — rénovation', url: 'https://www.habitatpresto.com/pro', gratuit: false },
      { nom: 'LesBonsArtisans.fr', desc: 'Demandes qualifiées, accompagnement personnalisé', url: 'https://www.lesbonsartisans.fr', gratuit: false },
    ]
  },
  {
    categorie: '🔧 Spécialisées BTP',
    items: [
      { nom: 'Hellio Pro', desc: 'Rénovation énergétique — isolation, chauffage, solaire (RGE)', url: 'https://www.hellio.com/pro', gratuit: true },
      { nom: 'Place des Chantiers', desc: 'Chantiers pré-qualifiés — moins de pertes de temps', url: 'https://www.placedeschantiers.fr', gratuit: false },
      { nom: 'TravauxMatch', desc: 'Mise en relation locale et directe avec particuliers', url: 'https://www.travauxmatch.fr', gratuit: true },
      { nom: 'VertuoWork', desc: 'Demandes de professionnels et particuliers', url: 'https://www.vertuowork.com', gratuit: true },
      { nom: 'Obat Travaux', desc: 'Fiche entreprise gratuite — forte visibilité sans commission', url: 'https://www.obat.fr', gratuit: true },
      { nom: 'ChantierAccess', desc: 'Mise en relation pro BTP — sous-traitance incluse', url: 'https://www.chantieraccess.fr', gratuit: false },
    ]
  },
  {
    categorie: '⚡ Dépannage & Urgences',
    items: [
      { nom: 'MesDépanneurs.fr', desc: 'Urgences — affilié Engie, forte demande', url: 'https://www.mesdepanneurs.fr', gratuit: false },
      { nom: 'HelloArtisan', desc: 'Petites réparations du quotidien et entretien', url: 'https://www.helloartisan.com', gratuit: true },
      { nom: 'Izi by EDF', desc: 'Construction, installation, entretien — caution EDF', url: 'https://izi.edf.fr', gratuit: false },
    ]
  },
  {
    categorie: '🏛️ Réseau professionnel',
    items: [
      { nom: 'TrouverMonArtisan.com', desc: 'Plateforme officielle CAPEB — particuliers et collectivités', url: 'https://www.trouvermonartisan.com', gratuit: true },
      { nom: 'La Maison Saint-Gobain', desc: 'Réseau qualité — caution Saint-Gobain', url: 'https://www.lamaisonsaintgobain.fr', gratuit: false },
    ]
  },
  {
    categorie: '📢 Petites annonces',
    items: [
      { nom: 'LeBonCoin', desc: 'Particuliers qui cherchent un artisan — très large audience', url: 'https://www.leboncoin.fr/recherche?category=109', gratuit: true },
      { nom: 'PAP.fr', desc: 'Annonces de travaux de particuliers', url: 'https://www.pap.fr/annonce/travaux', gratuit: true },
      { nom: 'Vivastreet', desc: 'Services à domicile et petits travaux', url: 'https://www.vivastreet.com/annonces/france/travaux', gratuit: true },
    ]
  },
  {
    categorie: '🏗️ Marchés publics',
    items: [
      { nom: 'BOAMP', desc: 'Bulletin officiel — tous les appels d\'offres publics', url: 'https://www.boamp.fr', gratuit: true },
      { nom: 'France Marchés', desc: 'Milliers d\'appels d\'offres BTP publics et privés', url: 'https://www.francemarches.com', gratuit: true },
      { nom: 'marchés.gouv.fr', desc: 'Plateforme officielle des marchés de l\'État', url: 'https://www.marches.gouv.fr', gratuit: true },
      { nom: 'Olmero', desc: 'Appels d\'offres privés et publics — très complet', url: 'https://www.olmero.fr', gratuit: false },
    ]
  },
];

export default function Chantiers({ artisan }) {
  const [tab, setTab] = useState('marches');
  const [metierSelec, setMetierSelec] = useState('maconnerie');
  const [departement, setDepartement] = useState('');
  const [loading, setLoading] = useState(false);

  const chargerMarches = async () => {
    if (!departement.trim()) {
      alert('Veuillez entrer un département ou une ville.');
      return;
    }
    setLoading(true);
    const metier = METIERS.find(m => m.id === metierSelec)?.label || 'BTP';
    const url = `https://www.boamp.fr/pages/recherche/?disjunctive.type_marche&disjunctive.code_dept&q=${encodeURIComponent(metier)}&refinement_filters=code_dept%3A%5B%22${encodeURIComponent(departement)}%22%5D`;
    window.open(url, '_blank');
    setLoading(false);
  };

  const tabs = [
    { id: 'marches', label: '🏗️ Marchés publics' },
    { id: 'plateformes', label: '⭐ Plateformes' },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#0a0a0a' }}>
      <div style={{ background: '#0d1117', padding: '14px 16px 12px', borderBottom: '0.5px solid #1a2744', flexShrink: 0 }}>
        <p style={{ color: '#e8eaf0', fontSize: 15, fontWeight: 600, margin: '0 0 10px' }}>Chantiers</p>
        <div style={{ display: 'flex', gap: 6 }}>
          {tabs.map(t => (
            <button key={t.id} onClick={() => setTab(t.id)} style={{
              background: tab === t.id ? '#FFD700' : '#111',
              color: tab === t.id ? '#0a0a0a' : '#4a7abf',
              border: `0.5px solid ${tab === t.id ? '#FFD700' : '#1a2744'}`,
              borderRadius: 20, padding: '5px 14px', fontSize: 12,
              fontWeight: 500, cursor: 'pointer', whiteSpace: 'nowrap',
            }}>{t.label}</button>
          ))}
        </div>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '14px' }}>

        {tab === 'marches' && (
          <>
            <div style={{ background: '#0e2040', border: '0.5px solid #1e3a6e', borderRadius: 10, padding: '10px 12px', marginBottom: 14 }}>
              <p style={{ fontSize: 11, color: '#85B7EB', margin: '0 0 4px', fontWeight: 500 }}>ℹ️ Comment ça marche ?</p>
              <p style={{ fontSize: 10, color: '#4a7abf', margin: 0, lineHeight: 1.5 }}>Sélectionnez votre métier et votre département — vous serez redirigé vers le BOAMP avec les appels d'offres filtrés pour vous. Répondez avec un devis généré en 1 minute depuis l'onglet Devis.</p>
            </div>

            <div style={{ background: '#0d1117', border: '0.5px solid #1a2744', borderRadius: 10, padding: '12px', marginBottom: 14 }}>
              <p style={{ fontSize: 11, color: '#FFD700', fontWeight: 600, margin: '0 0 10px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Filtres</p>
              <div style={{ marginBottom: 10 }}>
                <label style={{ fontSize: 11, color: '#4a7abf', display: 'block', marginBottom: 4 }}>Votre métier</label>
                <select value={metierSelec} onChange={e => setMetierSelec(e.target.value)}
                  style={{ width: '100%', background: '#111', border: '0.5px solid #1a2744', borderRadius: 8, padding: '8px 10px', fontSize: 13, color: '#c8d4e8', outline: 'none' }}>
                  {METIERS.map(m => <option key={m.id} value={m.id}>{m.label}</option>)}
                </select>
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 11, color: '#4a7abf', display: 'block', marginBottom: 4 }}>Département (ex: 34, 75...)</label>
                <input value={departement} onChange={e => setDepartement(e.target.value)}
                  placeholder="Numéro ou nom du département"
                  style={{ width: '100%', background: '#111', border: '0.5px solid #1a2744', borderRadius: 8, padding: '8px 10px', fontSize: 13, color: '#c8d4e8', outline: 'none', boxSizing: 'border-box' }} />
              </div>
              <button onClick={chargerMarches} disabled={loading} style={{ width: '100%', background: loading ? '#1a2744' : '#FFD700', color: loading ? '#4a7abf' : '#0a0a0a', border: 'none', borderRadius: 20, padding: '10px 0', fontSize: 13, fontWeight: 700, cursor: loading ? 'default' : 'pointer' }}>
                {loading ? 'Ouverture en cours…' : '🔍 Voir les appels d\'offres'}
              </button>
            </div>

            <p style={{ fontSize: 11, color: '#4a7abf', margin: '0 0 8px', fontWeight: 500 }}>Autres sources officielles :</p>
            {[
              { nom: 'France Marchés', desc: 'Milliers d\'appels d\'offres publics et privés', url: 'https://www.francemarches.com', color: '#4caf7d' },
              { nom: 'marchés.gouv.fr', desc: 'Plateforme officielle des marchés de l\'État', url: 'https://www.marches.gouv.fr', color: '#85B7EB' },
              { nom: 'Olmero', desc: 'Appels d\'offres privés et publics — très complet', url: 'https://www.olmero.fr', color: '#f0a500' },
            ].map(s => (
              <div key={s.nom} style={{ background: '#0d1117', border: '0.5px solid #1a2744', borderRadius: 10, padding: '10px 12px', marginBottom: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <p style={{ color: '#e8eaf0', fontSize: 12, fontWeight: 500, margin: '0 0 2px' }}>{s.nom}</p>
                  <p style={{ color: '#4a7abf', fontSize: 10, margin: 0 }}>{s.desc}</p>
                </div>
                <a href={s.url} target="_blank" rel="noopener noreferrer"
                  style={{ background: '#111', border: `0.5px solid ${s.color}`, borderRadius: 8, padding: '5px 10px', fontSize: 10, color: s.color, textDecoration: 'none', fontWeight: 500, flexShrink: 0, marginLeft: 8 }}>
                  Accéder →
                </a>
              </div>
            ))}
          </>
        )}

        {tab === 'plateformes' && (
          <>
            <div style={{ background: '#0e2040', border: '0.5px solid #1e3a6e', borderRadius: 10, padding: '10px 12px', marginBottom: 14 }}>
              <p style={{ fontSize: 11, color: '#85B7EB', margin: '0 0 4px', fontWeight: 500 }}>💡 Conseil Compagnon</p>
              <p style={{ fontSize: 10, color: '#4a7abf', margin: 0, lineHeight: 1.5 }}>Inscrivez-vous sur 2 ou 3 plateformes maximum pour commencer — mieux vaut soigner son profil sur quelques sites que d'être partout sans suivi. Répondez dans les 30 minutes pour multiplier vos chances par 7.</p>
            </div>

            {PLATEFORMES.map(cat => (
              <div key={cat.categorie} style={{ marginBottom: 16 }}>
                <p style={{ fontSize: 11, color: '#FFD700', fontWeight: 600, margin: '0 0 8px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{cat.categorie}</p>
                {cat.items.map(p => (
                  <div key={p.nom} style={{ background: '#0d1117', border: '0.5px solid #1a2744', borderRadius: 10, padding: '10px 12px', marginBottom: 6 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
                      <div style={{ flex: 1, marginRight: 8 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2 }}>
                          <p style={{ color: '#e8eaf0', fontSize: 12, fontWeight: 500, margin: 0 }}>{p.nom}</p>
                          {p.gratuit && (
                            <span style={{ fontSize: 9, padding: '1px 6px', borderRadius: 10, background: '#0e2a1a', color: '#4caf7d', fontWeight: 600 }}>GRATUIT</span>
                          )}
                        </div>
                        <p style={{ color: '#4a7abf', fontSize: 10, margin: 0, lineHeight: 1.4 }}>{p.desc}</p>
                      </div>
                      <a href={p.url} target="_blank" rel="noopener noreferrer"
                        style={{ background: '#0e2040', border: '0.5px solid #1e3a6e', borderRadius: 8, padding: '5px 10px', fontSize: 10, color: '#85B7EB', textDecoration: 'none', fontWeight: 500, flexShrink: 0 }}>
                        Accéder →
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </>
        )}

      </div>
    </div>
  );
}
